import { useSelector } from 'react-redux'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import { Form, Modal, Tab, Tabs, Button, Accordion } from "react-bootstrap";

import close_img from '../../../assets/images/close.svg'
import trash_img from '../../../assets/images/trash.svg'
import UploadButton from '../../../components/UploadButton';
import { API_URL } from '../../../config/constants';
import AddGroupInput from '../../UsersScreen/_components/AddGroupInput';
import GroupReducedTable from '../../UsersScreen/_components/GroupReducedTable';
import { useState } from 'react';
import { toast } from 'react-toastify';


export default function FolderInfo (props) {

    const t = useSelector(selectTranslations)
    const [groupsRowSelection, setGroupsRowSelection] = useState({})
    const [selectedActionType, setSelectedActionType] = useState('')
    const [newActionData, setNewActionData] = useState({})

    const handleEdit = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        console.log(target.name, target.type, target.value)
        props.setFolderData({
            ...props.folderData,
            [name]: value,
            ...((name === "type" && value === "learning_path" ) &&{
                learning_path_completed_actions: props.folderData?.learning_path_completed_actions || []
            })
        })
    }

    const handleEditState = (e) => {
        console.log(e)
        props.setFolderData({
            ...props.folderData,
            state: e?.target?.checked ? "ready" : "draft"
        })
    }

    const handleEditFolderIcon = (e) => {
        props.setFolderData({
            ...props.folderData,
            icon_url: e
        })
    }

    const handleAddAction = () => {
        if (!selectedActionType) {
            toast.error("Seleziona un tipo di azione")
            return
        }

        const currentActions = props.folderData?.learning_path_completed_actions || []
        let newAction = { type: selectedActionType }

        switch (selectedActionType) {
            case 'mark_learning_path_as_completed':
                // Controlla che non esista già
                if (currentActions.find(a => a.type === 'mark_learning_path_as_completed')) {
                    toast.error("Azione già presente")
                    return
                }
                break
            case 'add_communication':
                if (!newActionData.communication_id) {
                    toast.error("Inserisci l'ID della comunicazione")
                    return
                }
                newAction.communication_id = newActionData.communication_id
                break
            case 'add_to_groups':
                if (!newActionData.group_ids || newActionData.group_ids.length === 0) {
                    toast.error("Aggiungi almeno un gruppo")
                    return
                }
                newAction.group_ids = newActionData.group_ids
                newAction.groups = newActionData.groups || []
                break
            default:
                return
        }

        props.setFolderData({
            ...props.folderData,
            learning_path_completed_actions: [...currentActions, newAction]
        })

        // Reset
        setSelectedActionType('')
        setNewActionData({})
    }

    const handleRemoveAction = (index) => {
        const currentActions = props.folderData?.learning_path_completed_actions || []
        props.setFolderData({
            ...props.folderData,
            learning_path_completed_actions: currentActions.filter((_, i) => i !== index)
        })
    }

    const handleAddGroupToAction = (actionIndex, group) => {
        const currentActions = props.folderData?.learning_path_completed_actions || []
        const action = currentActions[actionIndex]
        
        if (action.type !== 'add_to_groups') return
        
        if (group && !action.groups?.find(u => u.group_id === group?.group_id)) {
            const updatedActions = currentActions.map((act, idx) => {
                if (idx === actionIndex) {
                    return {
                        ...act,
                        groups: [...act.groups || [], group],
                        group_ids: [...act.group_ids || [], group.group_id]
                    }
                }
                return act
            })
            
            props.setFolderData({
                ...props.folderData,
                learning_path_completed_actions: updatedActions
            })
        } else {
            toast.error(t.groups.error_adding_group)
        }
    }

    const handleRemoveGroupsFromAction = (actionIndex, groupIdsToRemove) => {
        const currentActions = props.folderData?.learning_path_completed_actions || []
        
        const updatedActions = currentActions.map((action, idx) => {
            if (idx === actionIndex && action.type === 'add_to_groups') {
                const filteredGroups = action.groups?.filter((e) => !groupIdsToRemove.includes(e.group_id)) || []
                const filteredGroupIds = action.group_ids?.filter((id) => !groupIdsToRemove.includes(id)) || []
                return { ...action, groups: filteredGroups, group_ids: filteredGroupIds }
            }
            return action
        })
        
        props.setFolderData({
            ...props.folderData,
            learning_path_completed_actions: updatedActions
        })
    }

    const handleAddGroupToNewAction = (group) => {
        if (group) {
            const currentGroups = newActionData.groups || []
            const currentGroupIds = newActionData.group_ids || []
            
            if (!currentGroups.find(g => g.group_id === group.group_id)) {
                setNewActionData({
                    ...newActionData,
                    groups: [...currentGroups, group],
                    group_ids: [...currentGroupIds, group.group_id]
                })
            } else {
                toast.error(t.groups.error_adding_group)
            }
        }
    }

    const handleRemoveGroupFromNewAction = (groupId) => {
        setNewActionData({
            ...newActionData,
            groups: (newActionData.groups || []).filter(g => g.group_id !== groupId),
            group_ids: (newActionData.group_ids || []).filter(id => id !== groupId)
        })
    }
    
 
    return (
        <Modal
            show={props.show}
            onHide={props.onClose}
            keyboard={true}
            centered
            size='lg'
        >
            <Modal.Body>
                    <div className='d-flex justify-content-between'>
                        <h4>Modifica cartella</h4>
                        <img src={close_img} className='pointer' onClick={props.onClose} />
                    </div>
                    {
                        props.folderData.state !== "deleted" &&
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="ready"
                                name="ready"
                                className='mt-2'
                                label={t.folder.visible_folder}
                                onChange={handleEditState}
                                checked={props.folderData.state === "ready"}
                            />
                    }
                    <div className='d-flex align-items-center mt-2'>
                        {
                            props.folderData?.icon_url &&
                                <img className='me-2' src={`${API_URL}${props.folderData.icon_url}`} style={{maxWidth:"45px"}} />
                        }
                        <UploadButton label={props.folderData?.icon_url ? t.folder.change_icon : t.folder.add_icon} type="personalization" accept="image/png, image/gif, image/jpeg" onUpload={handleEditFolderIcon} showProgress={true} />
                    </div>
                    
                    <Form.Group controlId="title" className='mt-2'>
                        <Form.Label>{t.folder.folder_name}*</Form.Label>
                        <Form.Control type="text" value={props.folderData.name || ''} name="name" placeholder={t.folder.folder_name} required onChange={handleEdit} />
                    </Form.Group>
                    <Form.Group controlId="description" className='mt-2'>
                        <Form.Label>{t.folder.folder_description}</Form.Label>
                        <Form.Control type="text" value={props.folderData.description || ''} name="description"  onChange={handleEdit} />
                    </Form.Group>
                    <Form.Label className='mt-3'>{t.folder.unlock_type}</Form.Label>
                    <div className="mb-3">
                        <Form.Check
                            inline
                            label="Standard"
                            name="type"
                            type={'radio'}
                            id={`standard`}
                            value={'standard'}
                            checked={props?.folderData?.type === 'standard' || !props?.folderData?.type }
                            onChange={handleEdit}
                        />
                        <Form.Check
                            inline
                            label="Sblocco progressivo"
                            name="type"
                            type={'radio'}
                            id={`learning_path`}
                            value="learning_path"
                            checked={props?.folderData?.type === 'learning_path'}
                            onChange={handleEdit}
                        />
                    </div>
                    {
                        props?.folderData?.type === 'learning_path' &&
                        <>
                            <Form.Label className='mt-3'>{t.folder.learning_path_completed_actions || "Azioni al completamento"}</Form.Label>
                            
                            {/* Lista azioni esistenti */}
                            {props.folderData?.learning_path_completed_actions?.length > 0 && (
                                <div className='mb-3'>
                                    {props.folderData.learning_path_completed_actions.map((action, index) => (
                                        <div key={index} className='border rounded p-3 mb-2'>
                                            <div className='d-flex justify-content-between align-items-center mb-2'>
                                                <strong>
                                                    {action.type === 'mark_learning_path_as_completed' && 'Marca percorso come completato'}
                                                    {action.type === 'add_communication' && 'Aggiungi comunicazione'}
                                                    {action.type === 'add_to_groups' && 'Aggiungi a gruppi'}
                                                </strong>
                                                <img 
                                                    src={trash_img} 
                                                    className='pointer' 
                                                    onClick={() => handleRemoveAction(index)}
                                                    alt="Rimuovi"
                                                />
                                            </div>
                                            
                                            {action.type === 'add_communication' && (
                                                <div>
                                                    <small>ID Comunicazione: {action.communication_id}</small>
                                                </div>
                                            )}
                                            
                                            {action.type === 'add_to_groups' && (
                                                <>
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <AddGroupInput 
                                                            onAddGroup={(group) => handleAddGroupToAction(index, group)} 
                                                            invalidGroups={action.groups?.map(g => g.group_id) || []} 
                                                            label={t.groups.add_group}
                                                        />
                                                    </div>
                                                    {action.groups?.length > 0 && (
                                                        <div>
                                                            {action.groups.map(group => (
                                                                <div key={group.group_id} className='d-flex justify-content-between align-items-center border-bottom py-1'>
                                                                    <small>{group.name}</small>
                                                                    <img 
                                                                        src={trash_img} 
                                                                        className='pointer' 
                                                                        style={{width: '16px'}}
                                                                        onClick={() => handleRemoveGroupsFromAction(index, [group.group_id])}
                                                                        alt="Rimuovi"
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                            
                            {/* Form per aggiungere nuova azione */}
                            <div className='border rounded p-3 bg-light'>
                                <h6>Aggiungi nuova azione</h6>
                                <Form.Group className='mt-2'>
                                    <Form.Label>Tipo di azione</Form.Label>
                                    <Form.Select 
                                        value={selectedActionType} 
                                        onChange={(e) => {
                                            setSelectedActionType(e.target.value)
                                            setNewActionData({})
                                        }}
                                    >
                                        <option value="">Seleziona...</option>
                                        <option value="mark_learning_path_as_completed">Marca percorso come completato</option>
                                        <option value="add_communication">Aggiungi comunicazione</option>
                                        <option value="add_to_groups">Aggiungi a gruppi</option>
                                    </Form.Select>
                                </Form.Group>
                                
                                {selectedActionType === 'add_communication' && (
                                    <Form.Group className='mt-2'>
                                        <Form.Label>ID Comunicazione</Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            value={newActionData.communication_id || ''} 
                                            onChange={(e) => setNewActionData({...newActionData, communication_id: e.target.value})}
                                            placeholder="Inserisci l'ID della comunicazione"
                                        />
                                    </Form.Group>
                                )}
                                
                                {selectedActionType === 'add_to_groups' && (
                                    <div className='mt-2'>
                                        <AddGroupInput 
                                            onAddGroup={handleAddGroupToNewAction} 
                                            invalidGroups={newActionData.groups?.map(g => g.group_id) || []} 
                                            label={t.groups.add_group}
                                        />
                                        {newActionData.groups?.length > 0 && (
                                            <div className='mt-2'>
                                                {newActionData.groups.map(group => (
                                                    <div key={group.group_id} className='d-flex justify-content-between align-items-center border-bottom py-1'>
                                                        <small>{group.name}</small>
                                                        <img 
                                                            src={trash_img} 
                                                            className='pointer' 
                                                            style={{width: '16px'}}
                                                            onClick={() => handleRemoveGroupFromNewAction(group.group_id)}
                                                            alt="Rimuovi"
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )}
                                
                                <Button 
                                    variant="primary" 
                                    className='mt-3 w-100' 
                                    onClick={handleAddAction}
                                    disabled={!selectedActionType}
                                >
                                    Aggiungi azione
                                </Button>
                            </div>
                        </>
                    }
            </Modal.Body>
        </Modal>
        
    )
}